module.exports = __webpack_public_path__ + "img/logo-even.4c123436.png";